'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _glamor = require('glamor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** classnamesUndefined */
var classnamesUndefined = function classnamesUndefined() {
  return _classnames2.default.apply(undefined, arguments) || undefined;
};
/** getScaleFactor */
var getScaleFactor = function getScaleFactor(arg) {
  return parseFloat(_lodash2.default.replace(arg, 'X', ''), 10) * 100 + '%';
};
var Fragment = _react2.default.Fragment;

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Caps

var caps = (0, _glamor.css)({
  textTransform: 'uppercase',
  letterSpacing: '-0.0625ex'
});
var capsClass = caps.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/** H3 */
var H3 = function H3(props) {
  return _react2.default.createElement(
    'h3',
    _extends({
      className: classnamesUndefined(props.className, props.mask && 'mask-' + props.mask, props.caps && capsClass),
      style: _extends({}, props.style)
    }, _lodash2.default.omit(props, ['className', 'style', 'mask'])),
    props.scale ? _react2.default.createElement(
      'span',
      { style: { fontSize: getScaleFactor(props.scale) } },
      props.children
    ) : _react2.default.createElement(
      Fragment,
      null,
      props.children
    )
  );
};

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------------ Types
// ------------------------------------------------------------------------------
H3.propTypes = process.env.NODE_ENV !== "production" ? {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Specific props
  mask: _propTypes2.default.string,
  scale: _propTypes2.default.string,
  caps: _propTypes2.default.bool,

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Generic props
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};

H3.defaultProps = {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Specific props
  mask: undefined,
  scale: undefined,
  caps: undefined,

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Generic props
  className: undefined,
  style: {}
};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = H3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/typography/lib/elements/H3.js
// module id = 468
// module chunks = 168707334958949